import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import newLogo from '../../assets/images/new_log_design.svg';

const EMt7anyLoader = ({
    text = "جاري التحميل...",
    isLoading = true,
    onAnimationComplete
}) => {
    return (
        <AnimatePresence mode="wait">
            {isLoading && (
                <motion.div
                    className="emthany-loader-container"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{
                        duration: 0.5,
                        ease: "easeInOut"
                    }}
                    onAnimationComplete={onAnimationComplete}
                >
                    {/* Animated Background Gradient */}
                    <motion.div
                        className="animated-bg"
                        animate={{
                            background: [
                                'radial-gradient(circle at 20% 50%, rgba(120, 119, 198, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(139, 92, 246, 0.3) 0%, transparent 50%), radial-gradient(circle at 40% 20%, rgba(167, 139, 250, 0.2) 0%, transparent 50%)',
                                'radial-gradient(circle at 80% 50%, rgba(120, 119, 198, 0.3) 0%, transparent 50%), radial-gradient(circle at 20% 20%, rgba(139, 92, 246, 0.3) 0%, transparent 50%), radial-gradient(circle at 60% 80%, rgba(167, 139, 250, 0.2) 0%, transparent 50%)',
                                'radial-gradient(circle at 20% 50%, rgba(120, 119, 198, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(139, 92, 246, 0.3) 0%, transparent 50%), radial-gradient(circle at 40% 20%, rgba(167, 139, 250, 0.2) 0%, transparent 50%)'
                            ]
                        }}
                        transition={{
                            duration: 8,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }}
                    />

                    {/* Glassmorphic Container */}
                    <motion.div
                        className="glass-container"
                        initial={{ opacity: 0, scale: 0.8, y: 50 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        transition={{
                            duration: 0.6,
                            ease: [0.34, 1.56, 0.64, 1],
                            delay: 0.1
                        }}
                    >
                        {/* Ripple Effects */}
                        <div className="ripple-container">
                            {[...Array(3)].map((_, index) => (
                                <motion.div
                                    key={index}
                                    className="ripple"
                                    animate={{
                                        scale: [0, 2.5],
                                        opacity: [0.6, 0]
                                    }}
                                    transition={{
                                        duration: 3,
                                        repeat: Infinity,
                                        delay: index * 1,
                                        ease: "easeOut"
                                    }}
                                />
                            ))}
                        </div>

                        {/* Logo Container with 3D Effect */}
                        <motion.div
                            className="logo-container"
                            animate={{
                                rotateY: [0, 10, -10, 0],
                                y: [0, -15, 0]
                            }}
                            transition={{
                                rotateY: { duration: 4, repeat: Infinity, ease: "easeInOut" },
                                y: { duration: 2.5, repeat: Infinity, ease: "easeInOut" }
                            }}
                        >
                            <motion.div
                                className="logo-wrapper"
                                animate={{
                                    scale: [1, 1.05, 1]
                                }}
                                transition={{
                                    duration: 2,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }}
                            >
                                <img
                                    src={newLogo}
                                    alt="امتحاني"
                                    className="emthany-logo"
                                />

                                {/* Orbital Rings */}
                                <motion.div
                                    className="orbital-ring ring-1"
                                    animate={{ rotate: 360 }}
                                    transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
                                />
                                <motion.div
                                    className="orbital-ring ring-2"
                                    animate={{ rotate: -360 }}
                                    transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
                                />
                                <motion.div
                                    className="orbital-ring ring-3"
                                    animate={{ rotate: 360 }}
                                    transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
                                />
                            </motion.div>

                            {/* Glow Effects */}
                            <motion.div
                                className="logo-glow"
                                animate={{
                                    scale: [1, 1.4, 1],
                                    opacity: [0.4, 0.8, 0.4]
                                }}
                                transition={{
                                    duration: 2,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }}
                            />
                        </motion.div>

                        {/* Loading Text with Gradient */}
                        <motion.div
                            className="loading-text-container"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3, duration: 0.5 }}
                        >
                            <motion.h2
                                className="loading-title"
                                animate={{
                                    backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
                                }}
                                transition={{
                                    duration: 3,
                                    repeat: Infinity,
                                    ease: "linear"
                                }}
                            >
                                امتحاني
                            </motion.h2>
                            <motion.p
                                className="loading-subtitle"
                                animate={{
                                    opacity: [0.6, 1, 0.6]
                                }}
                                transition={{
                                    duration: 2,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }}
                            >
                                {text}
                            </motion.p>
                        </motion.div>

                        {/* Modern Progress Bar */}
                        <motion.div
                            className="progress-container"
                            initial={{ opacity: 0, scaleX: 0 }}
                            animate={{ opacity: 1, scaleX: 1 }}
                            transition={{ delay: 0.5, duration: 0.6 }}
                        >
                            <div className="progress-track">
                                <motion.div
                                    className="progress-fill"
                                    animate={{
                                        x: ['-100%', '100%']
                                    }}
                                    transition={{
                                        duration: 1.5,
                                        repeat: Infinity,
                                        ease: "easeInOut"
                                    }}
                                />
                                <motion.div
                                    className="progress-glow"
                                    animate={{
                                        x: ['-100%', '100%']
                                    }}
                                    transition={{
                                        duration: 1.5,
                                        repeat: Infinity,
                                        ease: "easeInOut"
                                    }}
                                />
                            </div>

                            {/* Progress Dots */}
                            <div className="progress-dots">
                                {[...Array(3)].map((_, index) => (
                                    <motion.div
                                        key={index}
                                        className="progress-dot"
                                        animate={{
                                            scale: [1, 1.5, 1],
                                            opacity: [0.3, 1, 0.3]
                                        }}
                                        transition={{
                                            duration: 1.5,
                                            repeat: Infinity,
                                            delay: index * 0.2
                                        }}
                                    />
                                ))}
                            </div>
                        </motion.div>
                    </motion.div>

                    {/* Enhanced Floating Particles */}
                    <div className="particles-container">
                        {[...Array(20)].map((_, index) => (
                            <motion.div
                                key={index}
                                className={`particle particle-${index % 3}`}
                                initial={{
                                    opacity: 0,
                                    scale: 0,
                                    x: Math.random() * window.innerWidth,
                                    y: Math.random() * window.innerHeight
                                }}
                                animate={{
                                    opacity: [0, 0.8, 0],
                                    scale: [0, 1, 0],
                                    y: [
                                        Math.random() * window.innerHeight,
                                        Math.random() * window.innerHeight - 200,
                                        Math.random() * window.innerHeight
                                    ],
                                    x: [
                                        Math.random() * window.innerWidth,
                                        Math.random() * window.innerWidth,
                                        Math.random() * window.innerWidth
                                    ]
                                }}
                                transition={{
                                    duration: 8 + Math.random() * 4,
                                    repeat: Infinity,
                                    delay: Math.random() * 2,
                                    ease: "easeInOut"
                                }}
                            />
                        ))}
                    </div>

                    <style jsx>{`
                        .emthany-loader-container {
                            position: fixed;
                            top: 0;
                            left: 0;
                            width: 100vw;
                            height: 100vh;
                            background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            z-index: 999999;
                            overflow: hidden;
                            font-family: 'Cairo', 'Tajawal', sans-serif;
                        }

                        .animated-bg {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            z-index: 1;
                        }

                        .glass-container {
                            position: relative;
                            z-index: 2;
                            background: rgba(255, 255, 255, 0.05);
                            backdrop-filter: blur(20px);
                            -webkit-backdrop-filter: blur(20px);
                            border-radius: 32px;
                            border: 1px solid rgba(255, 255, 255, 0.1);
                            padding: 4rem 3rem;
                            box-shadow: 
                                0 8px 32px 0 rgba(31, 38, 135, 0.37),
                                inset 0 1px 1px 0 rgba(255, 255, 255, 0.1);
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            gap: 2.5rem;
                            min-width: 400px;
                        }

                        .ripple-container {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 200px;
                            height: 200px;
                            pointer-events: none;
                        }

                        .ripple {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 100%;
                            height: 100%;
                            border: 2px solid rgba(167, 139, 250, 0.6);
                            border-radius: 50%;
                        }

                        .logo-container {
                            position: relative;
                            width: 160px;
                            height: 160px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            perspective: 1000px;
                            transform-style: preserve-3d;
                        }

                        .logo-wrapper {
                            position: relative;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }

                        .emthany-logo {
                            width: 120px;
                            height: 120px;
                            object-fit: contain;
                            filter: drop-shadow(0 10px 40px rgba(167, 139, 250, 0.6));
                            z-index: 3;
                            position: relative;
                        }

                        .orbital-ring {
                            position: absolute;
                            border-radius: 50%;
                            border: 2px solid transparent;
                            border-top-color: rgba(167, 139, 250, 0.6);
                            border-right-color: rgba(139, 92, 246, 0.4);
                        }

                        .ring-1 {
                            width: 140px;
                            height: 140px;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }

                        .ring-2 {
                            width: 160px;
                            height: 160px;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            border-top-color: rgba(139, 92, 246, 0.5);
                            border-right-color: rgba(120, 119, 198, 0.3);
                        }

                        .ring-3 {
                            width: 180px;
                            height: 180px;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            border-top-color: rgba(120, 119, 198, 0.4);
                            border-right-color: rgba(167, 139, 250, 0.2);
                        }

                        .logo-glow {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 200px;
                            height: 200px;
                            background: radial-gradient(circle, rgba(167, 139, 250, 0.4) 0%, transparent 70%);
                            border-radius: 50%;
                            filter: blur(30px);
                            z-index: 1;
                        }

                        .loading-text-container {
                            text-align: center;
                            color: white;
                            z-index: 2;
                        }

                        .loading-title {
                            font-size: 3rem;
                            font-weight: 900;
                            margin: 0 0 0.75rem 0;
                            background: linear-gradient(
                                90deg,
                                #a78bfa 0%,
                                #c4b5fd 25%,
                                #e9d5ff 50%,
                                #c4b5fd 75%,
                                #a78bfa 100%
                            );
                            background-size: 200% auto;
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                            background-clip: text;
                            text-shadow: 0 0 30px rgba(167, 139, 250, 0.5);
                            letter-spacing: 2px;
                        }

                        .loading-subtitle {
                            font-size: 1.25rem;
                            font-weight: 500;
                            margin: 0;
                            color: rgba(255, 255, 255, 0.9);
                            text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
                        }

                        .progress-container {
                            width: 320px;
                            display: flex;
                            flex-direction: column;
                            gap: 1rem;
                            align-items: center;
                        }

                        .progress-track {
                            width: 100%;
                            height: 8px;
                            background: rgba(255, 255, 255, 0.1);
                            border-radius: 10px;
                            overflow: hidden;
                            position: relative;
                            box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
                        }

                        .progress-fill {
                            position: absolute;
                            top: 0;
                            left: 0;
                            height: 100%;
                            width: 40%;
                            background: linear-gradient(90deg, 
                                transparent 0%,
                                rgba(167, 139, 250, 0.8) 50%,
                                transparent 100%
                            );
                            border-radius: 10px;
                        }

                        .progress-glow {
                            position: absolute;
                            top: -4px;
                            left: 0;
                            height: 16px;
                            width: 60px;
                            background: radial-gradient(ellipse, rgba(167, 139, 250, 0.6) 0%, transparent 70%);
                            filter: blur(8px);
                        }

                        .progress-dots {
                            display: flex;
                            gap: 0.75rem;
                        }

                        .progress-dot {
                            width: 10px;
                            height: 10px;
                            background: rgba(167, 139, 250, 0.8);
                            border-radius: 50%;
                            box-shadow: 0 0 10px rgba(167, 139, 250, 0.6);
                        }

                        .particles-container {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            pointer-events: none;
                            z-index: 1;
                        }

                        .particle {
                            position: absolute;
                            border-radius: 50%;
                            pointer-events: none;
                        }

                        .particle-0 {
                            width: 6px;
                            height: 6px;
                            background: radial-gradient(circle, rgba(167, 139, 250, 0.8) 0%, transparent 70%);
                            box-shadow: 0 0 15px rgba(167, 139, 250, 0.8);
                        }

                        .particle-1 {
                            width: 4px;
                            height: 4px;
                            background: radial-gradient(circle, rgba(139, 92, 246, 0.8) 0%, transparent 70%);
                            box-shadow: 0 0 12px rgba(139, 92, 246, 0.8);
                        }

                        .particle-2 {
                            width: 8px;
                            height: 8px;
                            background: radial-gradient(circle, rgba(120, 119, 198, 0.6) 0%, transparent 70%);
                            box-shadow: 0 0 18px rgba(120, 119, 198, 0.6);
                        }

                        /* Responsive Design */
                        @media (max-width: 768px) {
                            .glass-container {
                                min-width: 320px;
                                padding: 3rem 2rem;
                                gap: 2rem;
                                border-radius: 24px;
                            }

                            .logo-container {
                                width: 140px;
                                height: 140px;
                            }

                            .emthany-logo {
                                width: 100px;
                                height: 100px;
                            }

                            .ring-1 { width: 120px; height: 120px; }
                            .ring-2 { width: 140px; height: 140px; }
                            .ring-3 { width: 160px; height: 160px; }

                            .loading-title {
                                font-size: 2.25rem;
                            }

                            .loading-subtitle {
                                font-size: 1.1rem;
                            }

                            .progress-container {
                                width: 280px;
                            }

                            .ripple-container {
                                width: 160px;
                                height: 160px;
                            }
                        }

                        @media (max-width: 480px) {
                            .glass-container {
                                min-width: 280px;
                                padding: 2.5rem 1.5rem;
                                gap: 1.75rem;
                                border-radius: 20px;
                            }

                            .logo-container {
                                width: 120px;
                                height: 120px;
                            }

                            .emthany-logo {
                                width: 80px;
                                height: 80px;
                            }

                            .ring-1 { width: 100px; height: 100px; }
                            .ring-2 { width: 120px; height: 120px; }
                            .ring-3 { width: 140px; height: 140px; }

                            .loading-title {
                                font-size: 2rem;
                                letter-spacing: 1px;
                            }

                            .loading-subtitle {
                                font-size: 1rem;
                            }

                            .progress-container {
                                width: 240px;
                            }

                            .progress-track {
                                height: 6px;
                            }

                            .ripple-container {
                                width: 140px;
                                height: 140px;
                            }
                        }

                        /* Landscape mobile */
                        @media (max-height: 500px) and (orientation: landscape) {
                            .glass-container {
                                padding: 1.5rem 2rem;
                                gap: 1rem;
                            }

                            .logo-container {
                                width: 80px;
                                height: 80px;
                            }

                            .emthany-logo {
                                width: 60px;
                                height: 60px;
                            }

                            .loading-title {
                                font-size: 1.5rem;
                            }

                            .loading-subtitle {
                                font-size: 0.9rem;
                            }
                        }
                    `}</style>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default EMt7anyLoader;

// Custom hook for easy loader usage with API calls
export const useEMt7anyLoader = () => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [loaderText, setLoaderText] = React.useState("جاري التحميل...");

    const showLoader = (text = "جاري التحميل...") => {
        setLoaderText(text);
        setIsLoading(true);
    };

    const hideLoader = () => {
        setIsLoading(false);
    };

    const withLoader = async (apiCall, loadingText = "جاري التحميل...") => {
        try {
            showLoader(loadingText);
            const result = await apiCall();
            return result;
        } finally {
            hideLoader();
        }
    };

    return {
        isLoading,
        loaderText,
        showLoader,
        hideLoader,
        withLoader,
        LoaderComponent: () => (
            <EMt7anyLoader
                isLoading={isLoading}
                text={loaderText}
                onAnimationComplete={() => {
                    // Optional: Add any logic that should run after animation completes
                }}
            />
        )
    };
};
